import { Button } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ResetPasswordModal from '../modals/resetPassword';

const ResetPasswordButton = () => {
    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const onClick = () => {
        setIsModalOpen(true);
    };
    const onCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <Button
                onClick={onClick}
                type="link"
                style={{ float: 'right', paddingRight: 0 }}
            >
                {t("login.forgotPassword")}
            </Button>
            {/* ----- Modal ----- */}
            <ResetPasswordModal isOpen={isModalOpen} onCancel={onCancel} />
        </>
    );
};

export default ResetPasswordButton;
